<!-- Banner -->
<div id="slider" class="banner carousel slide carousel-fade">
	<!-- Wrapper for Slides -->
	<div class="carousel-inner">
		<div class="item active">
			<!-- Set the first background image using inline CSS below. -->
			<div class="fill" style="background-image:url({{urlHost}}{{sliderFirst.imagePath}});">
				<!-- <img src="{{urlHost}}{{slider.imagePath}}" class="img-fluid"> -->
				<div class="banner-content">
					<div class="container">
						<div class="row">
							<div class="banner-text {{sliderFirst.cssClass}}">
								<div class="animated fadeInRight">
									<h1>{{sliderFirst.name}}</h1>
									<p innerHTML="{{sliderFirst.subTitle}}"></p>
									<div class="btn-banner">
										<!-- <a class="btn solid-btn" href="service.html">Xem dịch vụ</a> -->
										<a class="btn solid-btn"
											[href]="sliderFirst.link">{{sliderFirst.buttonName}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="item" *ngFor="let slider of sliders">
			<!-- Set the first background image using inline CSS below. -->
			<div class="fill" style="background-image:url({{urlHost}}{{slider.imagePath}});">
				<!-- <img src="{{urlHost}}{{slider.imagePath}}" class="img-fluid"> -->
				<div class="banner-content">
					<div class="container">
						<div class="row">
							<div class="banner-text {{slider.cssClass}}">
								<div class="animated fadeInRight">
									<h1>{{slider.name}}</h1>
									<p innerHTML="{{slider.subTitle}}"></p>
									<div class="btn-banner">
										<!-- <a class="btn solid-btn" href="service.html">Xem dịch vụ</a> -->
										<a class="btn solid-btn" href="{{slider.link}}">{{slider.buttonName}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="item">
				<div class="fill" style="background-image:url('assets/App_Themes/image/banner-2.jpg');">
					<div class="banner-content">
						<div class="container">
							<div class="row">
								<div class="banner-text f-w text-center w-color">
									<div class="animated fadeInUp">
										<h1 class="w-heading">WORLD CLASS <br> SHIPPING SERVICES</h1>
										<p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto.</p>
										<div class="btn-banner">
											<a class="btn solid-btn" href="service.html">our services</a>
											<a class="btn trns-btn-w" href="get-a-quote.html">get a quote</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>					
				</div>
			</div> -->
		<!-- <div class="item">
				<div class="fill" style="background-image:url('assets/App_Themes/image/banner-3.jpg');">
					<div class="banner-content">
						<div class="container">
							<div class="row">
								<div class="banner-text text-right w-color pull-right">
									<div class="animated fadeInLeft">
										<h1 class="w-heading">WORLD WIDE <br> TRANSPORT SERVICE</h1>
										<p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto.</p>
										<div class="btn-banner animated">
											<a class="btn solid-btn" href="service.html">our services</a>
											<a class="btn trns-btn-w" href="get-a-quote.html">get a quote</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>					
				</div>
			</div> -->
	</div>
	<!-- Left and right controls -->
	<a class="left carousel-control" href="#slider" role="button" data-slide="prev">
		<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
		<span class="sr-only">Trở lại</span>
	</a>
	<a class="right carousel-control" href="#slider" role="button" data-slide="next">
		<span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
		<span class="sr-only">Tiếp theo</span>
	</a>
</div>
<!-- End banner -->